interface Feature {
	name: string
	description: string
	codename: string
	legacyFeatureExpiryDate: string
}

type FeatureObject = Record<string, Feature>

export const features: FeatureObject = {
	breadcrumbs: {
		name: 'Breadcrumbs',
		description:
			"<p>The new breadcrumbs approach will be created according to the URLs. For example the full URL would be dissected to allow us to retrieve each page's breadcrumb title e.g. /our-products/seresto/seresto-dogs would allow us to get each page's information '/our-products', '/our-products/seresto' and '/our-products/seresto/seresto-dogs', as long as the URL matches the one in Kontent CMS the breadcrumbs would appear.</p><p>The automated breadcrumbs approached implemented in Jira ticket GWP-148. Should you want to revert back the changes, disable the option.</p>",
		codename: 'feature_breadcrumbs',
		legacyFeatureExpiryDate: '27 March 2024',
	},
	geoLocationPopup: {
		name: 'Geo Location Popup',
		description:
			"<p>Geo Location Popup feature allows you to show a popup to users when their location does not match the site's locale. This is useful for guiding users to the correct regional site.</p><p>When enabled, the popup will appear for users whose origin country does not match the site's locale. The popup will provide an option to switch to the correct regional site or continue on the current site.</p><p><strong>Note:</strong> This feature flag is affiliate-specific. Enabling it will only affect the current affiliate/market site, not all sites globally.</p>",
		codename: 'feature_geo_location_popup',
		legacyFeatureExpiryDate: '11 June 2025',
	},
	noindexGatedPages: {
		name: 'Noindex Gated Pages',
		description:
			"<p>When enabled, pages with an authentication gate of '2 - Logged In' or '3 - Logged In with a Validated Account' will emit a <code>noindex,nofollow</code> meta-robots tag, instructing search engines not to index them. This aligns the meta-robots behaviour with the existing sitemap.xml exclusion of gated pages and prevents auth-gated pages from being indexed with cookie-banner metadata (GWP-5938).</p><p>The per-page <code>External Noindex</code> field continues to take precedence as a per-page override.</p><p><strong>Note:</strong> This feature flag is affiliate-specific. Enabling it only affects the current affiliate/market site.</p>",
		codename: 'feature_noindex_gated_pages',
		legacyFeatureExpiryDate: '21 May 2026',
	},
	fibrYpayPilot: {
		name: 'Fibr YPAY Pilot',
		description:
			'<p>Enables the Fibr pilot integration on the approved US YPAY campaign pages only.</p><p>Approved pilot pages:</p><ul><li><code>/us/campaign/credelio-quattro-dog</code></li><li><code>/us/campaign/stop-sucking-with-seresto</code></li></ul><p>This feature flag is affiliate-specific and should be used as the primary rollback mechanism for the pilot.</p>',
		codename: 'feature_fibr_ypay_pilot',
		legacyFeatureExpiryDate: '31 December 2026',
	},
	// Add more features here
	/*
    Example 
    featureName: {
		name: FEATURE_NAME USED IN MAC GUIDELINES,
		description: FEATURE_DESCRIPTION USED IN MAC GUIDELINES,
		codename: FEATURE_CODENAME USED IN MAC CHOICE AND TO ENABLE FEATURE IN MATCH CODE,
		legacyFeatureExpiryDate: DATE USED IN MAC GUIDELINES,
	},
    */
}

export const featureFlagOptions = Object.values(features).map(
	(feature: Feature) => ({
		name: feature.name,
		codename: feature.codename,
	})
)
export const featureGuidelines = `
<h3>Features Toggle</h3><p>Use the guidelines below to enable the features you require</p>
<table>
	<tbody>
		<tr>
			<td><h5>Feature Name</h5></td>
			<td><h5>Description</h5></td>
			<td><h5>Legacy feature expiry date</h5></td>
		</tr>
		${Object.values(features)
			.map(
				(feature: Feature) => `
				<tr>
					<td>${feature.name}</td>
					<td>${feature.description}</td>
					<td>${feature.legacyFeatureExpiryDate}</td>
				</tr>
			`
			)
			.join('')}
	</tbody>
</table>
`
